import{css as t}from"@mui/material/styles";import e from"styled-components";const i=e("div")`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: ${({theme:t,$hasDescription:e})=>e?t.spacing(25):t.spacing(20)};
  margin-bottom: ${({theme:t,$hasDescription:e})=>e&&t.spacing(4)};

  img {
    display: block;
    max-width: 100%;
    height: auto;
    margin-bottom: ${({theme:t})=>t.spacing(3)};
  }

  h1 {
    margin-top: ${({theme:t})=>t.spacing(0)};
    margin-bottom: ${({theme:t,$hasDescription:e})=>e?t.spacing(2):t.spacing(20)};
    font-size: 60px;
    font-weight: ${({theme:t})=>t.typography.fontWeightRegular};
    hyphens: auto;
    line-height: 1.2;
    ${({theme:t})=>t.breakpoints.down("md")} {
      margin-bottom: ${({theme:t,$hasDescription:e})=>e&&t.spacing(0)};
      font-size: ${({theme:t})=>t.typography.h1.fontSize};
    }
  }

  ${({$hasCampaign:e,$hasSubheading:i})=>e&&t`
      padding-top: ${({theme:t})=>t.spacing(25)};
      ${i?t`
            margin-bottom: ${({theme:t})=>t.spacing(4)};
          `:t`
            margin-bottom: ${({theme:t})=>t.spacing(2)};
          `}

      img {
        margin-bottom: ${({theme:t})=>t.spacing(6)};
      }

      h1 {
        width: fit-content;
        padding: 8px 24px;
        margin-bottom: ${({theme:t})=>t.spacing(1)};
        font-size: 60px;
        font-weight: ${({theme:t})=>t.typography.h1.fontWeight};
        line-height: 1.2;
        color: ${({theme:t})=>t.palette.white.main};
        text-transform: uppercase;
        background-color: ${({theme:t})=>t.palette.blue60.main};
        ${({theme:t})=>t.breakpoints.down("md")} {
          padding: ${({theme:t})=>t.spacing(2,4)};
          font-size: 32px;
        }
      }
    `}
`;export{i as HeadingDiv};
//# sourceMappingURL=styles.js.map
